import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { getBatchesPostData } from 'ducks/batches/utils';
import { getProject } from 'ducks/project/operators';
import { getProjects } from 'ducks/projects/operators';
import { updateSettings } from 'ducks/settings/slices';
import { Slices } from 'ducks/slices';
import { ProjectsBatchesListAPI } from 'ducks/types/api-types';
import { Query } from 'ducks/types/query-types';
import { store } from 'store';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';
import { replaceSearchQuery } from 'utils/queries';

export const getBatches = createAsyncThunk<ProjectsBatchesListAPI[], { project_id: number; data?: Query }>(
  `${Slices.BATCHES}/get`,
  async ({ project_id, data }, { rejectWithValue }) => {
    try {
      const post_data = getBatchesPostData(data);
      const route = `/projects/${project_id}/batches/list${replaceSearchQuery(post_data)}`;
      const res: AxiosResponse['data'] = await Andromeda.get(route);
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);

export const getBatchesPage = async (project_id: number, data?: Query) => {
  store.dispatch(updateSettings({ loading: true }));
  const res: AxiosResponse['data'] = await Promise.all([
    store.dispatch(getProjects(data)),
    store.dispatch(getProject(project_id)),
    store.dispatch(getBatches({ project_id, data })),
  ]);
  store.dispatch(updateSettings({ loading: false }));
  return res;
};
